export const sortRequests = (requests = []) =>  {
  const sortedData = [...requests]?.sort((a, b) => {
      return new Date(a.required_date_start) - new Date(b.required_date_start);
  });

  return sortedData;
};